<template>
  <div style="width: 100%">
    <cash-register-top-bar
      v-if="registerType === 'cash'"
    ></cash-register-top-bar>
    <panel-register-top-bar
      v-if="
        registerType === 'panel' ||
        registerType === 'ai-caffe-wide' ||
        registerType === 'bottom-up' ||
        registerType === 'ai-crud' ||
        registerType === 'ai-compact' ||
        registerType === 'ai-shop'
      "
    ></panel-register-top-bar>
  </div>
</template>

<script>
import { df } from '@/plugins/firebase'
import state from '@/state'
import EventBus from '@/plugins/event-bus'
import CashRegisterTopBar from '@/components/top-bar/components/CashRegisterTopBar'
import PanelRegisterTopBar from '@/components/top-bar/components/PanelRegisterTopBar'

const CUTOFF = new Date('2026-06-28T00:00:00Z').getTime()
function isNewRegister (doc) {
  if (!doc || !doc.created) return false
  try {
    const ms = doc.created.toDate ? doc.created.toDate().getTime()
      : doc.created.seconds ? doc.created.seconds * 1000
      : typeof doc.created === 'number' ? doc.created * 1000
      : null
    return ms !== null && ms >= CUTOFF
  } catch (_) { return false }
}

export default {
  components: {
    CashRegisterTopBar,
    PanelRegisterTopBar
  },
  data () {
    return {
      registerType: undefined
    }
  },
  methods: {
    async setRegisterTemplate () {
      const register = await df.doc(`cash_registers/${state.getCashRegister().id}`).get()
      if (register && register.data()) {
        const doc = register.data()
        if (doc && doc.register_template) {
          state.setRegisterType(doc.register_template)
        } else {
          state.setRegisterType(isNewRegister(doc) ? 'ai-shop' : 'ai-crud')
        }
      } else {
        state.setRegisterType('ai-crud')
      }
      this.registerType = state.getRegisterType()
    }
  },
  async created () {
    this.setRegisterTemplate()

    EventBus.$on('change-register-template', () => {
      this.registerType = state.getRegisterType()
    })
  }
}
</script>
